import React from 'react';
import PaymentResultPage from './PaymentResultPage';

export default function PaymentFailedPage() {
  return <PaymentResultPage status="FAILED" />;
}
